import { Grid, Typography } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import { get, isEmpty, values, without } from 'lodash'
import { useState } from 'react'
import { Button, email as emailValidator, useGetList, useNotify } from 'react-admin'

import { addStaffUsers } from '../../api/core'
import { captureExceptionIfProduction } from '../../helpers/utils'

const AddStaffUser = ({ resource }: any) => {
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const [email, setEmail] = useState('')
  const emailInputErrorMessage = get(emailValidator('Email is not valid.')(email, {}), 'message', '')

  const { data, loading: areGroupsLoading } = useGetList(resource)
  const groups = values(data)

  const [selectedGroups, setSelectedGroups] = useState<any>([])

  const notify = useNotify()

  return (
    <>
      <Button onClick={() => setDialogOpen(true)} label="Add Staff User">
        <AddCircleIcon />
      </Button>
      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add New Staff User</DialogTitle>
        <DialogContent>
          {isLoading || areGroupsLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="20vh">
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Box>
                <DialogContentText>What's the user's CloudTrucks email address?</DialogContentText>
                <TextField
                  label="Email"
                  variant="outlined"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  error={!!emailInputErrorMessage}
                  helperText={emailInputErrorMessage}
                  required
                  fullWidth
                />
              </Box>
              <Box mt={2}>
                <DialogContentText>Permission Groups</DialogContentText>
                {groups.map((group) => (
                  <Box key={group.id}>
                    <Grid container>
                      <Grid item>
                        <Checkbox
                          onChange={(event) =>
                            event.target.checked
                              ? setSelectedGroups([...selectedGroups, group.id])
                              : setSelectedGroups(without(selectedGroups, group.id))
                          }
                        />
                      </Grid>
                      <Grid item>
                        <Box mt={1}>
                          <Typography>{group.name}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              </Box>
              <Box mt={2}>
                <DialogContentText>
                  <Box sx={{ fontStyle: 'italic' }}>
                    Note: users will then have to visit{' '}
                    <a href={window.location.origin + '/ct-admin/password_reset/'}>this page</a> to set their
                    password. They should receive an email with instructions.
                  </Box>
                </DialogContentText>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} label="Cancel" disabled={isLoading} />
          <Button
            variant="contained"
            disabled={!!emailInputErrorMessage || !email || isLoading || isEmpty(selectedGroups)}
            onClick={async () => {
              try {
                setLoading(true)
                const isOK = await addStaffUsers([email], selectedGroups)
                if (isOK) {
                  setDialogOpen(false)
                  setLoading(false)
                  setSelectedGroups([])
                  setEmail('')
                  notify('Created User!', { type: 'success' })
                } else {
                  throw new Error('Failed to create user.')
                }
              } catch (error) {
                setDialogOpen(false)
                setLoading(false)
                setSelectedGroups([])
                setEmail('')
                notify(`Oops, something went wrong: ${JSON.stringify(error)}`, { type: 'error' })
                captureExceptionIfProduction(error)
              }
            }}
            label="Create User"
          />
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AddStaffUser
